import { Selector } from 'react-redux';
import { RootState } from '../../redux/root-reducer';
import { IEventInitialState, IManagedEvent } from '../../redux/events/types';
import { createSelector } from 'reselect';

export const eventInitialStateSelector: Selector<RootState, IEventInitialState> = createSelector(
    (state: RootState) => state.events,
    event => event,
);

interface IManagedEventSelector {
    managedEvent?: IManagedEvent;
    updatingEvent?: boolean;
    managedEventError?: any;
    managedEventLoading?: boolean;
}
export const managedEventSelector: Selector<RootState, IManagedEventSelector> = createSelector(
    [eventInitialStateSelector],
    state => ({
        managedEvent: state.managedEvent,
        updatingEvent: state.updatingEvent,
        managedEventError: state.managedEventError,
        managedEventLoading: state.managedEventLoading,
    }),
);
